<template>
  <div
    class="category-featured-item"
    v-for="item of FEATURED_LIST"
    :key="item.name"
    @click="onItemClick(item)"
  >
    <span class="prefix">{{ item.prefix }}</span>
    {{ TRANSLATE_MAP[language.current][item.name] }}
    <img
      class="category-featured-item__icon"
      src="@/assets/layouts/choices.svg"
    >
  </div>
</template>

<script setup>
import { FEATURED_LIST, TRANSLATE_MAP } from '@/utils/constants'
import { useLanguageStore } from '@/pinia/language'

const emit = defineEmits(['click'])
const router = useRouter()

const language = useLanguageStore()

/**
 * @param {Object} item - The item of the FEATURED_LIST
 *
 * This function is triggered when a featured category item is clicked.
 * It navigates the user to the corresponding category page and emits the 'click' event
/*************  ✨ Windsurf Command ⭐  *************/
/** *****  c5cb2148-4d71-4fc8-b4a7-8c0eae1c80d7  *******/
const onItemClick = (item) => {
  router.push(item.path)
  emit('click', item)
}
</script>

<style lang="less" scoped>
@hoverColor: #009de0;

.category-featured-item {
  scroll-snap-align: start;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 4px;
  padding: 7px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-family: mon-600;
  cursor: pointer;

  &:hover {
    background-color: #F4F7FF;
  }

  &__icon {
    width: 60px;
    height: 18px;
  }
}
</style>
